import type { SnapshotManifest } from '@cli-types/core-engine/snapshots.js'
import { BARREL_SCOPE } from '@cli-constants/snapshots.js'
import { listSnapshotScopes } from './list-snapshot-scopes.js'
import { loadManifest } from './load-manifest.js'

export function loadAllManifests(
  cwd: string
): Array<{ scope: string; manifest: SnapshotManifest }> {
  return listSnapshotScopes(cwd)
    .filter((scope) => scope !== BARREL_SCOPE)
    .map((scope) => ({ scope, manifest: loadManifest(cwd, scope) }))
    .filter(
      (entry): entry is { scope: string; manifest: SnapshotManifest } => entry.manifest !== null
    )
}
